// City name localization for PT/FR/EN
// Falls back to stored name if no translation found

const CITY_TRANSLATIONS = {
  // Portugal
  'lisbon': { en: 'Lisbon', fr: 'Lisbonne', pt: 'Lisboa' },
  'lisboa': { en: 'Lisbon', fr: 'Lisbonne', pt: 'Lisboa' },
  'lisbonne': { en: 'Lisbon', fr: 'Lisbonne', pt: 'Lisboa' },
  'porto': { en: 'Porto', fr: 'Porto', pt: 'Porto' },
  'oporto': { en: 'Porto', fr: 'Porto', pt: 'Porto' },
  'faro': { en: 'Faro', fr: 'Faro', pt: 'Faro' },
  'coimbra': { en: 'Coimbra', fr: 'Coimbra', pt: 'Coimbra' },
  'braga': { en: 'Braga', fr: 'Braga', pt: 'Braga' },
  'funchal': { en: 'Funchal', fr: 'Funchal', pt: 'Funchal' },
  'aveiro': { en: 'Aveiro', fr: 'Aveiro', pt: 'Aveiro' },
  'evora': { en: 'Evora', fr: 'Évora', pt: 'Évora' },
  'setubal': { en: 'Setubal', fr: 'Setúbal', pt: 'Setúbal' },

  // France
  'paris': { en: 'Paris', fr: 'Paris', pt: 'Paris' },
  'lyon': { en: 'Lyon', fr: 'Lyon', pt: 'Lyon' },
  'marseille': { en: 'Marseille', fr: 'Marseille', pt: 'Marselha' },
  'toulouse': { en: 'Toulouse', fr: 'Toulouse', pt: 'Toulouse' },
  'nice': { en: 'Nice', fr: 'Nice', pt: 'Nice' },
  'nantes': { en: 'Nantes', fr: 'Nantes', pt: 'Nantes' },
  'strasbourg': { en: 'Strasbourg', fr: 'Strasbourg', pt: 'Estrasburgo' },
  'montpellier': { en: 'Montpellier', fr: 'Montpellier', pt: 'Montpellier' },
  'bordeaux': { en: 'Bordeaux', fr: 'Bordeaux', pt: 'Bordéus' },
  'lille': { en: 'Lille', fr: 'Lille', pt: 'Lille' },
  'rennes': { en: 'Rennes', fr: 'Rennes', pt: 'Rennes' },

  // Switzerland
  'zurich': { en: 'Zurich', fr: 'Zurich', pt: 'Zurique' },
  'zürich': { en: 'Zurich', fr: 'Zurich', pt: 'Zurique' },
  'geneva': { en: 'Geneva', fr: 'Genève', pt: 'Genebra' },
  'geneve': { en: 'Geneva', fr: 'Genève', pt: 'Genebra' },
  'genève': { en: 'Geneva', fr: 'Genève', pt: 'Genebra' },
  'bern': { en: 'Bern', fr: 'Berne', pt: 'Berna' },
  'berne': { en: 'Bern', fr: 'Berne', pt: 'Berna' },
  'basel': { en: 'Basel', fr: 'Bâle', pt: 'Basileia' },
  'lausanne': { en: 'Lausanne', fr: 'Lausanne', pt: 'Lausana' },

  // Luxembourg
  'luxembourg': { en: 'Luxembourg', fr: 'Luxembourg', pt: 'Luxemburgo' },
  'luxemburg': { en: 'Luxembourg', fr: 'Luxembourg', pt: 'Luxemburgo' },
  'esch-sur-alzette': { en: 'Esch-sur-Alzette', fr: 'Esch-sur-Alzette', pt: 'Esch-sur-Alzette' },

  // Belgium
  'brussels': { en: 'Brussels', fr: 'Bruxelles', pt: 'Bruxelas' },
  'bruxelles': { en: 'Brussels', fr: 'Bruxelles', pt: 'Bruxelas' },
  'bruxelas': { en: 'Brussels', fr: 'Bruxelles', pt: 'Bruxelas' },
  'antwerp': { en: 'Antwerp', fr: 'Anvers', pt: 'Antuérpia' },
  'anvers': { en: 'Antwerp', fr: 'Anvers', pt: 'Antuérpia' },
  'ghent': { en: 'Ghent', fr: 'Gand', pt: 'Gante' },
  'gand': { en: 'Ghent', fr: 'Gand', pt: 'Gante' },
  'liege': { en: 'Liège', fr: 'Liège', pt: 'Liège' },

  // Germany
  'berlin': { en: 'Berlin', fr: 'Berlin', pt: 'Berlim' },
  'munich': { en: 'Munich', fr: 'Munich', pt: 'Munique' },
  'münchen': { en: 'Munich', fr: 'Munich', pt: 'Munique' },
  'hamburg': { en: 'Hamburg', fr: 'Hambourg', pt: 'Hamburgo' },
  'hambourg': { en: 'Hamburg', fr: 'Hambourg', pt: 'Hamburgo' },
  'frankfurt': { en: 'Frankfurt', fr: 'Francfort', pt: 'Frankfurt' },
  'cologne': { en: 'Cologne', fr: 'Cologne', pt: 'Colónia' },
  'düsseldorf': { en: 'Düsseldorf', fr: 'Düsseldorf', pt: 'Düsseldorf' },
  'dusseldorf': { en: 'Düsseldorf', fr: 'Düsseldorf', pt: 'Düsseldorf' },
  'stuttgart': { en: 'Stuttgart', fr: 'Stuttgart', pt: 'Estugarda' },

  // Spain
  'madrid': { en: 'Madrid', fr: 'Madrid', pt: 'Madrid' },
  'barcelona': { en: 'Barcelona', fr: 'Barcelone', pt: 'Barcelona' },
  'barcelone': { en: 'Barcelona', fr: 'Barcelone', pt: 'Barcelona' },
  'valencia': { en: 'Valencia', fr: 'Valence', pt: 'Valência' },
  'valence': { en: 'Valencia', fr: 'Valence', pt: 'Valência' },
  'seville': { en: 'Seville', fr: 'Séville', pt: 'Sevilha' },
  'séville': { en: 'Seville', fr: 'Séville', pt: 'Sevilha' },
  'sevilla': { en: 'Seville', fr: 'Séville', pt: 'Sevilha' },
  'malaga': { en: 'Malaga', fr: 'Malaga', pt: 'Málaga' },
  'bilbao': { en: 'Bilbao', fr: 'Bilbao', pt: 'Bilbau' },
};

/**
 * Translate a city name to the given language.
 * @param {string} cityName - The stored city name
 * @param {string} lang - 'en', 'fr', or 'pt'
 * @returns {string} Translated city name, or original if not found
 */
export function localizeCity(cityName, lang = 'en') {
  if (!cityName) return '';
  const key = cityName.toLowerCase().trim();
  const entry = CITY_TRANSLATIONS[key];
  if (entry && entry[lang]) return entry[lang];
  // Fallback: capitalize original
  return cityName;
}

export default localizeCity;
